import { createReducer } from '@reduxjs/toolkit'

import { receivedReservation, setGiftCardsMode } from '../actions/actions'
import { GIFT_CARDS, SERIAL_TICKETS } from '../utils/mode'
import { isGiftCardType } from '../utils/serialTickets'

const initialState = SERIAL_TICKETS

const mode = createReducer(initialState, {
  [setGiftCardsMode]: () => GIFT_CARDS,
  [receivedReservation]: (state, { payload: reservation }) => {
    const isGiftCardReservation = reservation.serialTickets.some(ticket => isGiftCardType(ticket.type))
    return isGiftCardReservation ? GIFT_CARDS : SERIAL_TICKETS
  }
})

export default mode
